export default {"src":"/_next/static/media/roadwise-financing-logo-white-fr.dcda8d1c.svg","height":46,"width":109,"blurWidth":0,"blurHeight":0};